import { render, staticRenderFns } from "./ColaboracaoAprovadaDropDown.vue?vue&type=template&id=27ec008a&scoped=true"
import script from "./ColaboracaoAprovadaDropDown.vue?vue&type=script&lang=js"
export * from "./ColaboracaoAprovadaDropDown.vue?vue&type=script&lang=js"
import style0 from "./ColaboracaoAprovadaDropDown.vue?vue&type=style&index=0&id=27ec008a&prod&lang=scss"
import style1 from "./ColaboracaoAprovadaDropDown.vue?vue&type=style&index=1&id=27ec008a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ec008a",
  null
  
)

export default component.exports